import {
  EVENT_KEY_ENTER,
  EVENT_KEY_SPACE_BAR,
} from '../../../../constants/event'
import { isEventKeyEnter } from '../../../../utils/events'

import { getNavigableSelectOptions } from './useSelectKeyDown.utils'

export function useSelectKeyDown({
  activeIndex,
  disabled,
  isOpen,
  multi,
  options,
  setOpen,
  onSelect,
}) {
  function handleKeyDown(event) {
    if (!disabled) {
      if (isOpen) {
        const activeOption = getNavigableSelectOptions(options)[activeIndex]

        if (
          isEventKeyEnter(event) &&
          Number.isFinite(activeIndex) &&
          activeOption
        ) {
          onSelect(activeOption)

          if (!multi) {
            event.target.blur() // remove focus from input after select item
          }
        }
      } else {
        switch (event.key) {
          case EVENT_KEY_ENTER:
          case EVENT_KEY_SPACE_BAR:
            setOpen(true)
            break

          default:
            break
        }
      }
    }
  }

  return { handleKeyDown }
}
